module.exports = __webpack_public_path__ + "static/media/logo192.95480150.png";